import { render, staticRenderFns } from "./quill.vue?vue&type=template&id=71025546&"
import script from "./quill.vue?vue&type=script&lang=js&"
export * from "./quill.vue?vue&type=script&lang=js&"
import style0 from "./quill.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports